import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-investeringstilskudd",
  templateUrl: "./investeringstilskudd.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class InvesteringstilskuddComponent implements OnInit {
  objectKeys = Object.keys;
  statistikkType = "Tilsagn";
  graferValgt = "soknader";
  valgtFilter: { [key: string]: NxCell[] } = null;
  grafIderForSoknad: string[] = [];
  grafIderForBelop: string[] = [];
  grafIderForPlasser: string[] = [];
  kpiListe: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. "],
      plasser: [
        "Antall omsorgsplasser",
        "Viser hvor mange omsorgsplasser (sykehjemsplasser og omsorgsboliger) som er knyttet til sakene som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. Det kan også søkes om tilskudd til f.eks. fellesareal, heving av teknisk standard og dagaktivitetssentre. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Tilsagn: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt."],
      plasser: [
        "Antall omsorgsplasser",
        "Viser hvor mange omsorgsplasser (sykehjemsplasser og omsorgsboliger) som er knyttet til sakene som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. Det kan også søkes om tilskudd til f.eks. fellesareal, heving av teknisk standard og dagaktivitetssentre. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Utbetaling: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt."],
      plasser: [
        "Antall omsorgsplasser",
        "Viser hvor mange omsorgsplasser (sykehjemsplasser og omsorgsboliger) som er knyttet til sakene som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. Det kan også søkes om tilskudd til f.eks. fellesareal, heving av teknisk standard og dagaktivitetssentre. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Forespørsel: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt."],
      plasser: [
        "Antall omsorgsplasser",
        "Viser hvor mange omsorgsplasser (sykehjemsplasser og omsorgsboliger) som er knyttet til sakene som har sendt inn forespørsel, søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. Det kan også søkes om tilskudd til f.eks. fellesareal, heving av teknisk standard og dagaktivitetssentre. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er forespurt om, søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "INVTILSKUDD", false, true);
    this.qlikService.setFilter("TypeTilstand", "Tilsagn", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Investeringstilskudd - Husbanken");
    this.grafIderForSoknad = ["inv-ant-saker-pr-fylke", "inv-ant-saker"];
    this.grafIderForPlasser = ["inv-ant-omsorgsplasser-pr-fylke", "inv-ant-omsorgsplasser"];
    this.grafIderForBelop = ["inv-belop-pr-fylke", "inv-belop"];
    this.kpiListe = ["INV Antall saker", "INV Beløp", "INV Fellesareal", "INV Antall sykehjemsplasser", "INV Antall omsorgsboliger", "INV Antall omsorgsplasser"];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    return this.typeTekst[this.statistikkType][this.graferValgt][0];
  }
}
